import {useEffect, useState} from "react";
import {base64DecodeUnicode, toastSuccess} from "../../../assets/functions";
import Loading from "../../../component/Loading/Loading";
import {getManagerHeader} from "../../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../../assets/Constants";
import {useNavigate, useParams} from "react-router-dom";
import CustomerForm from "../component/CustomerForm/CustomerForm";
import {getCustomerById} from "../functions";
import Select from "../../../component/Select/Select";
import TextInput from "../../../component/TextInput/TextInput";
import Modal from "react-modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye} from "@fortawesome/free-solid-svg-icons";
import {PickDateTime, PickDateTimeWithoutContainer} from "../../../component/PickDate/PickDate";

const UpdateCustomer = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const staticLogin = {
        username: "",
        password: "",
    };
    const address = {
        townId: "1",
        address: "",
        picture: "",
        location : {
            lat : "",
            lng : ""
        }
    };
    const person = {
        firstname: "",
        lastname: "",
        profile: "",
        sex: "MALE",
        phonenumbers: [],
        activePhonenumber: "",
        nickname: "",
        birthday: Math.round(+new Date() / 1000),
        addresses: [{...address}],
        staticLogin: {...staticLogin},
    }
    const userLevelOptions = [
        {
            label: "انتخاب کنید...",
            value: "CHOOSING"
        }, {
            label: "عادی",
            value: "NORMAL"
        },
        {
            label: "نقره ای",
            value: "SILVER"
        },
        {
            label: "طلایی",
            value: "GOLD"
        }
    ];
    const [showUserLevelHistoryModal, setShowUserLevelHistoryModal] = useState(false);
    const [customer, setCustomer] = useState({
        person: {...person},
        representativeCustomerId: "",
        newLevel: {
            level: "",
            monthNumber: "",
        }
    });


    useEffect(() => {
        (async () => {
            document.title = "ویرایش مشتری";
            const customer = await getCustomerById(id);
            setCustomer({
                ...customer,
                newLevel: {
                    level: "",
                    monthNumber: "",
                }
            })
            console.log(customer);
            setIsLoading(false);
        })();

    }, []);

    const handleSubmit = async () => {
        setIsLoading(true);
        const headers = getManagerHeader();
        console.log(customer)
        axios.put(baseCmsApiUrl + 'customers', customer, {headers})
            .then((response) => {
                console.log(response)
                toastSuccess(base64DecodeUnicode(response.statusText));
                navigate("/customers");
                return;
            })
            .catch((e) => {
                console.error(e)
                console.log(base64DecodeUnicode(e.response.statusText))
                console.log(e.response.data)
            }).finally(() => {
            setIsLoading(false)
        })
    }

    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">ویرایش مشتری</h1>

                <FontAwesomeIcon className={"btn btn-primary me-2"} icon={faEye} width={30} onClick={() => {
                    setShowUserLevelHistoryModal(true);
                }}/>

                {showUserLevelHistoryModal &&
                    <LevelHistoryModal levelHistory={customer.levelHistory} closeModal={() => {
                        setShowUserLevelHistoryModal(false);
                    }}/>}
            </div>

            <CustomerForm customer={customer} onChange={(value) => {
                setCustomer(value);
            }}/>

            <div className="row">
                <div className="col-md-6">
                    <Select options={userLevelOptions} label={"سطح کاربری"} value={customer.newLevel.level}
                            onChange={(value) => {
                                const newLevel = {...customer.newLevel};
                                if (value == "CHOOSING") {
                                    newLevel.level = "";
                                    newLevel.monthNumber = "";
                                } else
                                    newLevel.level = value;

                                setCustomer({...customer, newLevel});
                            }}/>
                </div>
                <div className="col-md-6">
                    <TextInput label={"تعداد ماه"} type={"number"} value={customer.newLevel.monthNumber}
                               onChange={(value) => {
                                   const newLevel = {...customer.newLevel, monthNumber: value};
                                   setCustomer({...customer, newLevel});
                               }}/>
                </div>
            </div>

            <button className={"btn btn-secondary btn-lg w-100"} onClick={handleSubmit} disabled={isLoading}>ویرایش
                مشتری
            </button>

        </div>
    )
}


const LevelHistoryModal = ({row, closeModal, levelHistory}) => {

    const [modalIsOpen, setIsOpen] = useState(true);

    function handleCloseModel() {
        closeModal();
    }

    return (
        <Modal ariaHideApp={false} isOpen={modalIsOpen} onRequestClose={handleCloseModel} contentLabel="Example Modal">
            <h2 className={"text-center my-2"}>تاریخچه سطح کاربری مشتری</h2>
            <div className="row">
                <table className={"table table-hover table-responsive text-center mt-5"}>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>ساعت شروع</th>
                        <th>ساعت پایان</th>
                        <th>سطح کاربری</th>
                        <th>ویرایش دهنده</th>
                    </tr>
                    </thead>
                    <tbody>
                    {levelHistory.map((level, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td><PickDateTimeWithoutContainer timestamp={level.startTimestamp} disabled={true}/></td>
                                <td><PickDateTimeWithoutContainer timestamp={level.expirationTimestamp} disabled={true}/></td>
                                <td>
                                    {level.level == "SILVER" ? "نقره ای" : ""}
                                    {level.level == "GOLD" ? "طلایی" : ""}
                                </td>
                                <td>
                                    {!level.manager && <span>سیستمی</span>}
                                    {level.manager && `${level.manager.person.firstname} ${level.manager.person.lastname}`}
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            </div>

            <button className={"btn btn-danger float-left"} onClick={handleCloseModel}>بستن</button>
        </Modal>);

};

export default UpdateCustomer;